import { ReactComponent as IconPlay } from './assets/baseline-play_arrow-24px.svg'
import { ReactComponent as IconPause } from './assets/baseline-pause-24px.svg'
import { ReactComponent as IconReplay } from './assets/baseline-replay-24px.svg'
import { ReactComponent as IconVolumeOff } from './assets/baseline-volume_off-24px.svg'
import { ReactComponent as IconVolumeOn } from './assets/baseline-volume_up-24px.svg'

export const iconsList = {
  'play': IconPlay,
  'pause': IconPause,
  'replay': IconReplay,
  'volume-off': IconVolumeOff,
  'volume-on': IconVolumeOn,
}
